import styled from 'styled-components/macro'
import {
  BaseColor,
  Breakpoint,
  breakpointStarting,
  rem,
  linkInline,
  spacing,
  themeColor,
  Typography,
  Picture,
  link,
} from '@unbounded/unbounded-components'

export const Container = styled.div`
  margin-bottom: ${spacing(0.75)};
  color: ${themeColor(BaseColor.shade_60)};
  display: flex;
  flex-direction: column;

  @media (${breakpointStarting(Breakpoint.md)}) {
    margin-top: ${spacing(2.5)};
  }
`

export const RowContainer = styled(Container)`
  flex-direction: row;
`

export const Text = styled.div``

export const Title = styled.h1`
  ${Typography.titleLarge};
`

export const Header = styled.h3`
  margin: ${spacing(2.5)} 0 ${spacing(1)};
  ${Typography.titleMedium};
`

export const Paragraph = styled.p`
  ${Typography.bodySmall};
  &:not(:last-child) {
    margin-bottom: ${spacing(1)};
  }
  color: ${themeColor(BaseColor.shade_50)};
  a {
    ${link};
  }
`

export const ParagraphStrong = styled(Paragraph)`
  ${Typography.textStrong};
  text-transform: uppercase;
`

export const Address = styled(Paragraph)`
  margin-top: ${spacing(2.5)};
`

export const Strong = styled.strong`
  ${Typography.textStrong};
`

export const Date = styled.p`
  ${Typography.labelMedium};
  ${Typography.textRegular};
  &:not(:last-child) {
    margin-bottom: ${spacing(2)};
  }
  color: ${themeColor(BaseColor.shade_50)};
`

export const InlineLink = styled.a`
  ${linkInline};
`

export const Link = styled.a`
  ${linkInline};
  display: block;
  margin-bottom: ${spacing(1)};

  p > & {
    display: inline;
    margin-bottom: 0;
  }
`

export const Navigation = styled.aside`
  display: none;
  width: ${rem(180)};
  flex-shrink: 0;
  margin-right: ${spacing(3)};

  @media (${breakpointStarting(Breakpoint.md)}) {
    display: block;
  }

  @media (${breakpointStarting(Breakpoint.xl)}) {
    width: ${rem(300)};
  }
`

export const List = styled.ul`
  list-style-position: outside;
  margin: ${spacing()};
`

export const ListElement = styled.li`
  list-style-type: disc;
  margin-top: ${spacing(0.5)};
`

export const ListHeader = styled.h2`
  ${Typography.titleMedium}
`

export const Image = styled(Picture)`
  justify-content: center;
  display: flex;
  margin: ${spacing(2)} 0;
`
